import { DateTime } from 'luxon'

export function isSameDay(first?: Date, second?: Date, timeZone = 'Europe/Paris') {
  if (!first || !second) return false

  const firstDt = DateTime.fromJSDate(first, { zone: timeZone }).startOf('day')
  const secondDt = DateTime.fromJSDate(second, { zone: timeZone }).startOf('day')

  return firstDt.hasSame(secondDt, 'day')
}

export const formatHour = (value: string, locale: string) => {
  const dt = DateTime.fromISO(value, {
    zone: 'Europe/Paris',
    locale,
  })

  return dt.toFormat("HH'h'mm")
}
